module.exports = __webpack_public_path__ + "static/img/shipin.a08a184c.png";